import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    color-scheme: dark;
  }
  * { 
    box-sizing: border-box; 
  }
  
  html {
    height: 100%;
    background: radial-gradient(1200px 800px at 80% -20%, ${({ theme }) => theme.colors.primaryGlow}, transparent),
                radial-gradient(900px 600px at -10% 20%, ${({ theme }) => theme.colors.accentGlow}, transparent),
                ${({ theme }) => theme.colors.bg};
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
  }
  
  body {
    margin: 0;
    min-height: 100vh;
    background: transparent;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, Apple Color Emoji, Segoe UI Emoji;
    color: ${({ theme }) => theme.colors.text};
    zoom: 0.8;
  }
  
  #root {
    min-height: 100vh;
    background: transparent;
  }
  
  a { 
    color: inherit; 
    text-decoration: none; 
  }
  
  button {
    font: inherit;
    cursor: pointer;
  }
`;


